import React, { Component } from 'react';
import { remove, includes, get } from 'lodash';

class MultiSelectInput extends Component {
  constructor(props) {
    super(props);
    this.onCheck = this.onCheck.bind(this);
    this.onUncheck = this.onUncheck.bind(this);
    this.onOptionChange = this.onOptionChange.bind(this);
    const value = get(props, 'input.value') || props.value || [];
    this.state = { value };
  }

  get name() {
    return get(this.props, 'input.name') || this.props.name;
  }

  onCheck(val) {
    this.updateValue([ ...this.state.value,  val]);
  }

  onUncheck(value) {
    const modifiedValue = [ ...this.state.value ];
    remove(modifiedValue, item => item === value);
    this.updateValue(modifiedValue);
  }

  onOptionChange(ev) {
    const { value } = ev.target;
    if (ev.target.checked) return this.onCheck(value);
    return this.onUncheck(value);
  }

  updateValue(value) {
    this.setState({ value });
    this.props.onBlur(makeEvent(value));
    this.props.onChange(makeEvent(value));
  }

  renderOptions() {
    return this.props.options.map((option, index) => {
      const key = `multi-select-option-${index}`;
      const className = `form-check-input ${key}`;
      const checked = includes(this.state.value, option.value) ? 'checked' : '';
      return (
        <div className="form-check" key={key}>
          <label className="form-check-label">
            <input
              type="checkbox"
              name={`${this.name}[${option.value}]`}
              className={className}
              onChange={this.onOptionChange}
              checked={checked}
              value={option.value}
            />
            {` ${option.value}`}
          </label>
        </div>
      )
    });
  }

  render() {
    const className = `multi-select-input ${this.props.className || ''}`;

    return (
      <div className={className}>
        {this.renderOptions()}
      </div>
    );
  }
}

MultiSelectInput.defaultProps = {
  onBlur: () => {},
  onChange: () => {},
};

const makeEvent = value => ({
  stopPropagation() {},
  preventDefault() {},
  target: { value },
});

export default MultiSelectInput;



// WEBPACK FOOTER //
// ./src/desktop/components/multi-select-input.js